var exports = {
  "og": "xe7b6e3d6--9c1c60--seller",
  "JM": "xe7b6e3d6--9c1c60--seller-title",
  "Mc": "xe7b6e3d6--9c1c60--seller-logo",
  "n9": "xe7b6e3d6--9c1c60--seller-info",
  "o4": "xe7b6e3d6--9c1c60--seller-name",
  "NU": "xe7b6e3d6--9c1c60--seller-label",
};

module.exports = exports;
